<script lang="ts">
	import { formatNumberWithSeparators } from "../../../functions";
	import ModalitaCalcoloEmissioni from "../../../models/PSCL/Elaborazione/ModalitaCalcoloEmissioni";

    export let data: ModalitaCalcoloEmissioni[] = [];
</script>
<table class="w-full text-xs border border-black table-fixed">
    <thead>
        <tr>
        <th class="border border-black">Modalità</th>
        <th class="border border-black">N° di automobilisti che si prevede cambino modalità</th>
        <th class="border border-black">Distanza media di percorrenza sola andata [km/singolo spostamento]</th>
        <th class="border border-black">Operatività delle misure [giorni/anno]</th>
        <th class="border border-black">Alimentazione</th>
        <th class="border border-black">N° viaggi [viaggi/giorno]</th>
        <th class="border border-black">Percorrenze [km/viaggio]</th>
        </tr>
    </thead>
    <tbody>
        {#if data?.length > 0}
            {#each data as modalita}
                <tr>
                    <td class="text-center border border-black">{modalita?.modalita}</td>
                    <td class="text-center border border-black">{formatNumberWithSeparators(modalita?.nAutomobilistiCambiamentoModalitaPrevisto)}</td>
                    <td class="text-center border border-black">{formatNumberWithSeparators(modalita?.distanzaMediaPercorrenzaAndata)}</td>
                    <td class="text-center border border-black">{modalita?.operativitaMisure}</td>
                    <td class="text-center border border-black">{modalita?.alimentazione}</td>
                    <td class="text-center border border-black">{formatNumberWithSeparators(modalita?.nViaggi)}</td>
                    <td class="text-center border border-black">{formatNumberWithSeparators(modalita?.percorrenze)}</td>
                </tr>
            {/each}
        {:else}
            <tr>
                <td class="text-center border border-black">Bicicletta</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
            </tr>
            <tr>
                <td class="text-center border border-black">Trasporto pubblico</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
            </tr>
            <tr>
                <td class="text-center border border-black">Car pooling</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
            </tr>
            <tr>
                <td class="border border-black">Car sharing</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
            </tr>
            <tr>
                <td class="border border-black">Scooter sharing</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
            </tr>
            <tr>
                <td class="border border-black">Bike sharing</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
            </tr>
            <tr>
                <td class="border border-black">Monopattini in sharing</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
            </tr>
            <tr>
                <td class="border border-black">Smart working</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
            </tr>
            <tr>
                <td class="border border-black">Navette</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
            </tr>
            <tr>
                <td class="text-center border border-black">Piedi</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
                <td class="text-center bg-blue-100 border border-black">-</td>
            </tr>
        {/if}
    </tbody>
</table>